module.exports = __webpack_public_path__ + "static/media/exyookay-how-to.8417166d.png";